import React from 'react';
import ModernAnalyticsDashboard from '../components/analytics/ModernAnalyticsDashboard';

function Analytics() {
  return <ModernAnalyticsDashboard />;
}

export default Analytics;